
import { Component, OnInit,Inject} from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { ClipboardService } from 'ngx-clipboard';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';


@Component({
  selector: 'app-campaign-status',
  templateUrl: './campaign-status.component.html',
  styleUrls: ['./campaign-status.component.scss'],
  providers: [TitleCasePipe]
})
export class CampaignStatusComponent implements OnInit {

  task:any;
  authToken = localStorage.getItem('token');
  remarks:any;
  btnStatus = false;
  constructor(
    private dialogRef: MatDialogRef<CampaignStatusComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private fb:FormBuilder,
    private clipBoardService: ClipBoardService,
    private _serverService:ServerService,
    public titleCasePipe: TitleCasePipe
    // @Inject(MAT_DIALOG_DATA)public data
    
  ) { 
    // console.log(this.data)
    this.task = this.data;
    // console.log(this.task)
  }

  ngOnInit() {
  }
  close() {
    this.dialogRef.close();
}
changeStatus(){
  this.btnStatus = true;
  let body = {
    'status':this.titleCasePipe.transform(this.task.status),
    'remarks':this.remarks
  }
  let url = this.task.campaignId;
  // Send formData to server
  this._serverService.updateCampaignDetails(url,body, this.authToken).subscribe(response => {
    
    // this.showComponentLoader = false;
    this.clipBoardService.showMessgeInText(`Campaign Status Changed Succesfully`, "success-snackbar");
    // this.getCampaignDetails();
    
    this.dialogRef.close(response);
  }, error => {
    console.error('Changing of Campaign Status failed', error);
    this.btnStatus = false;
    // this.showComponentLoader = false;
  });
  // console.log("hi")
  // let body = 
  //     {
  //       "campaign_id": this.task.campaign_id,
  //       "status":this.task.new_status,
  //       "description":this.remarks
  //   }
  //   // return;
  //   let url = this.task.id
  //   this._serverService.campaignTaskStatusChange(url,body,this.authToken).subscribe((data)=>{
  //     this.clipBoardService.showMessgeInText("Task Status Updated Succesfully", "success-snackbar")
  //     this.dialogRef.close(data);
  //     // console.log(data)
  //   },err=>{
  //     this.clipBoardService.showMessgeInText(err, "error-snackbar")
  //   })
  //   // console.log(event.target.value)
  }

}